var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"color":"indigo","height":"60px","max-height":"60px","prominent":"prominent","dense":"dense"}})}
var staticRenderFns = []

export { render, staticRenderFns }